import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { CircleNotch, ShieldWarning } from '@phosphor-icons/react';

const ProtectedRoute = ({ children, pageKey }) => {
  const { user, loading, hasPage } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading-screen">
        <div className="text-center">
          <CircleNotch size={40} className="text-[#002FA7] animate-spin mx-auto mb-4" />
          <p className="text-sm text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (pageKey && !hasPage(pageKey)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="access-denied-screen">
        <div className="text-center max-w-md px-6">
          <ShieldWarning size={48} weight="duotone" className="text-slate-400 mx-auto mb-4" />
          <p className="text-lg font-medium text-slate-800 mb-2">Access restricted</p>
          <p className="text-sm text-slate-600">
            You don't have permission to view this page. Contact an administrator if you believe this is a mistake.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
